import React, { Fragment } from "react";
import { useLiquitySelector } from "@liquity/lib-react";
import { CRITICAL_COLLATERAL_RATIO, LiquityStoreState, CollateralBaseState, CollateralDerivedState } from "@liquity/lib-base";
import { MyTrove } from "./MyTrove";
import { CollateralLexicons } from "src/lexicon";
import { merge } from "lodash";

type ResultSelector = Pick<CollateralBaseState & CollateralDerivedState, "price" | "total" | "trove"> & { key: string, hasSurplusCollateral: boolean }

const select = ({ collateralStates, collateralDerivedStates }: LiquityStoreState) => {
  const states = merge(collateralStates, collateralDerivedStates)

  const selected = Object.entries(states).reduce<ResultSelector[]>((acc, [key, value]) => {
    const { price, total, collateralSurplusBalance, trove } = value
    if (trove.status === "open" || trove.status === "closedByLiquidation" ) {
      acc.push({ key, price, total, trove, hasSurplusCollateral: !collateralSurplusBalance.isZero})
    }
    return acc
  }, [])
  return selected
};

export const MyTroves: React.FC = () => {
  // NOTE: This will be multiple troves in the future
  const troveInfoList = useLiquitySelector(select);

  return (
    <div className="bg-component border-component pt-6 px-5 flex flex-col h-full">
      <div className="flex flex-row items-center justify-start mb-1">
        <div className="text-style-value">Borrowed</div>
      </div>
      <div className="divide-y divide-clearWhite">
        {troveInfoList.map((troveInfo, idx) => {
          const { key, price, total, trove, hasSurplusCollateral } = troveInfo
          const lexicon = CollateralLexicons.find(lexicon => lexicon.key === key)

          const isRecoveryMode = total.collateralRatio(price).lt(CRITICAL_COLLATERAL_RATIO);
          return (
            <Fragment key={idx}>
              {lexicon && (
                <MyTrove
                  collateralKey={key}
                  collateralName={lexicon.name}
                  // TODO-PSY: debt or netDebt?
                  totalMinted={total.debt.prettify(0)}
                  collateral={trove.collateral.prettify(2)}
                  debt={trove.debt.prettify()}
                  collateralRatio={trove.collateralRatio(price)}
                  status={trove.status}
                  hasSurplusCollateral={hasSurplusCollateral}
                  lexicon={lexicon}
                  isRecoveryMode={isRecoveryMode}
                  key={idx}
                />
              )}
            </Fragment>
          )
        })}
      </div>
    </div>
  );
};
